import React, { useEffect } from "react"
import { createContext, useContext, useState } from "react"
import { ModalManager } from "./ModalManager"

export const ModalContext = createContext()

export const ModalContenxtProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalType, setModalType] = useState("registration")

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflowY = "hidden"
    } else {
      document.body.style.overflowY = ""
    }
    return () => {
      document.body.style.overflowY = "auto"
    }
  }, [isModalOpen])

  return (
    <ModalContext.Provider
      value={{
        modalType: modalType,
        isModalOpen: isModalOpen,
        setIsModalOpen: setIsModalOpen,
        setModalType: setModalType,
      }}
    >
      <ModalManager />
      {children}
    </ModalContext.Provider>
  )
}

export const useModalContext = () => useContext(ModalContext)
